import * as React from "react";
import { withLabel } from "@/helpers/withLabel";
import type { SvyCheckboxProps } from "./SvyCheckbox.interface";
import { CheckboxRoot, CheckboxIndicator } from "./SvyCheckbox.style";
import { SvyIcon } from "@/indicators";

const InnerSvyCheckbox = React.forwardRef<HTMLButtonElement, SvyCheckboxProps>(({ value, onChange, ...props }, ref) => (
    <CheckboxRoot
        ref={ref}
        data-testid="svy-checkbox"
        checked={value}
        onCheckedChange={onChange}
        aria-label={props.id}
        {...props}
    >
        <CheckboxIndicator>
            <SvyIcon icon="check-line" />
        </CheckboxIndicator>
    </CheckboxRoot>
));

InnerSvyCheckbox.displayName = "SvyCheckbox";

export const SvyCheckbox = withLabel(InnerSvyCheckbox, { orientation: "horizontal-reverse" });
